import React from 'react';
import styled from 'styled-components';

const HeroSection = styled.section`
  padding: ${props => props.theme.spacing.section} 0 ${props => props.theme.spacing.xl} 0;
  text-align: center;
`;

const Title = styled.h1`
  margin-bottom: 1rem;
`;

const Subtitle = styled.p`
  font-size: ${props => props.theme.typography.h5};
  color: ${props => props.theme.colors.text.secondary};
  margin-bottom: 2rem;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
`;

export const ContentHeader = ({ title, subtitle }) => {
  return (
    <HeroSection>
      <Title data-cursor-text>{title}</Title>
      <Subtitle data-cursor-text>{subtitle}</Subtitle>
    </HeroSection>
  );
};